import { Callout } from '@/components/Callout/Callout'

export const ArtifactChangedCallout = () => (
  <Callout.Root>
    <Callout.Header>
      <Callout.Title>Transcript changed</Callout.Title>
    </Callout.Header>
    <Callout.Description>
      The source transcript changed since this document was created. Some verdicts may no longer match. Review before
      continuing.
    </Callout.Description>
  </Callout.Root>
)
